// lib
import proj4 from 'proj4';

// turf
import * as turf from '@turf/turf';

export const createRectangleGeoRecord = () => {
    const createRectangle = (centroid, width, height, courseSrid) => {
        const convertedCentroid = turf.toMercator(turf.point(centroid));
        const coordinate = proj4(
            'EPSG:3857',
            `EPSG:${courseSrid}`,
            convertedCentroid?.geometry?.coordinates,
        );

        const point1 = proj4(`EPSG:${courseSrid}`, 'EPSG:3857', [
            coordinate[0],
            coordinate[1],
        ]);
        const point2 = proj4(`EPSG:${courseSrid}`, 'EPSG:3857', [
            coordinate[0] + width,
            coordinate[1],
        ]);
        const point3 = proj4(`EPSG:${courseSrid}`, 'EPSG:3857', [
            coordinate[0] + width,
            coordinate[1] + height,
        ]);
        const point4 = proj4(`EPSG:${courseSrid}`, 'EPSG:3857', [
            coordinate[0],
            coordinate[1] + height,
        ]);

        const convertedPoint1 = turf.toWgs84(turf.point(point1));
        const convertedPoint2 = turf.toWgs84(turf.point(point2));
        const convertedPoint3 = turf.toWgs84(turf.point(point3));
        const convertedPoint4 = turf.toWgs84(turf.point(point4));

        let newGeometry = {
            type: 'Polygon',
            coordinates: [
                [
                    convertedPoint1.geometry?.coordinates,
                    convertedPoint2.geometry?.coordinates,
                    convertedPoint3.geometry?.coordinates,
                    convertedPoint4.geometry?.coordinates,
                    convertedPoint1.geometry?.coordinates,
                ],
            ],
        };
        return newGeometry;
    };

    return { createRectangle };
};
